import { Button, Flex, VisuallyHidden } from '@/components/ui';
import LogoMain from '@/components/LogoMain';
import Navigation from '@/components/Navigation';
import StudySelector from '@/components/StudySelector';
// import UploadQueueWidget from '@/components/UploadQueueWidget';
import UserMenu from '@/components/UserMenu';
import { useUploadPermissions } from '@/hooks/useUploadPermissions';
import { useSidebar } from '@/providers/SidebarContext';
import { Link } from 'react-router-dom';

import {
  IconLayoutSidebarLeftCollapseFilled,
  IconLayoutSidebarLeftExpand,
} from '@tabler/icons-react';
import UploadQueueWidget from '@/components/UploadQueueWidget/UploadQueueWidget.tsx';

const Header = () => {
  const { toggleSidebar, isOpen } = useSidebar();
  const { hasAnyUploadAccess } = useUploadPermissions();

  return (
    <div className="app-layout__header">
      <div className="header-theme">
        <Flex className="header__left" align="center" gap="2">
          <Button
            as={Link}
            to="/"
            variant="ghost"
            size="small"
            className="logo-button"
          >
            <LogoMain />
          </Button>

          <VisuallyHidden>
            <Button
              size="small"
              variant="soft"
              highContrast
              isIconOnly
              onClick={toggleSidebar}
              className="sidebar-toggle-button"
              aria-label="Open sidebar"
              ml="2"
            >
              {isOpen ? (
                <IconLayoutSidebarLeftCollapseFilled />
              ) : (
                <IconLayoutSidebarLeftExpand />
              )}
            </Button>
          </VisuallyHidden>
          <Navigation />
        </Flex>

        <Flex className="header__center" align="center"></Flex>

        <Flex className="header__right" align="center" gap="4">
          {hasAnyUploadAccess && <UploadQueueWidget />}
          <StudySelector />
          <UserMenu />
          {/*<MockDataManager />*/}
        </Flex>
      </div>
    </div>
  );
};

export default Header;
